import React, { useState, useEffect } from "react";
import { Flex, Popover, Skeleton, Space, Form, Row, Col } from "antd";
import Pies from "../../../assets/images/pies.svg";
import SqlImg from "../../../assets/images/sql.svg";
import Fx from "../../../assets/images/fx.svg";
import Sjfx from "../../../assets/images/sjfx.svg";
import Sjjd from "../../../assets/images/sjjd.svg";
import SJly from "../../../assets/images/sjly.svg";
import PieImg from "../../../assets/images/pie.svg";
import ZhuImg from "../../../assets/images/zhu.svg";
import ZxImg from "../../../assets/images/zx.svg";
import TableImg from "../../../assets/images/table.svg";
import "./index.less";
import EchartsData from "./echart";

function GbiContent(props) {
  const {
    title,
    attributionable,
    interpretationable,
    forecastable,
    filters,
    data,
    default_chart,
    support_charts,
    chart_data,
  } = props;

  /*
   name: field,
   label:fieldName,
   required:required,
   defaultValue: value,
   placeholder: example,
   type:type,
   options:options,
  */
  console.log(props, "我是gbiprops");

  const parseJSONString = (str) => {
    if (typeof str !== "string") {
      return { valid: false, error: "输入必须是字符串", data: null };
    }

    try {
      const data = JSON.parse(str);
      return { valid: true, data: data, error: null };
    } catch (e) {
      return { valid: false, data: null, error: e.message };
    }
  };

  const searchParams = parseJSONString(filters);
  // const supportCharts = parseJSONString(support_charts);
  const supportCharts = {
    data:["line","bar","pie","table"]
  };
  const charaData = parseJSONString(chart_data);
  const gyfx = parseJSONString(attributionable);
  const [chatType, setChatType] = useState(default_chart);
  console.log(searchParams,"")
  return (
    <div>
      <div className="info">
        <div className="title">{title}：</div>
        <div className="imgs">
          <Space>
            <Popover
              className="imgPopover"
              placement="bottomRight"
              content={
                <>
                  <div className="imgTitle">图标切换</div>
                  <div className="chooseType">
                    <Flex wrap gap={16} justify="space-around">
                      {supportCharts?.data?.includes("pie") ? (
                        <img
                          src={PieImg}
                          onClick={() => {
                            setChatType("pie");
                          }}
                        />
                      ) : undefined}
                      {supportCharts?.data?.includes("bar") ? (
                        <img
                          src={ZhuImg}
                          onClick={() => {
                            setChatType("bar");
                          }}
                        />
                      ) : undefined}
                      {supportCharts?.data?.includes("line") ? (
                        <img
                          src={ZxImg}
                          onClick={() => {
                            setChatType("line");
                          }}
                        />
                      ) : undefined}
                      {supportCharts?.data?.includes("table") ? (
                        <img
                          src={TableImg}
                          onClick={() => {
                            setChatType("table");
                          }}
                        />
                      ) : undefined}
                    </Flex>
                  </div>
                </>
              }
            >
              <img src={Pies} />
            </Popover>
            <img src={SqlImg} />
            <img src={Fx} />
            <img src={Sjfx} />
            <img src={Sjjd} />
            <img src={SJly} />
          </Space>
        </div>
      </div>
      <div className="filters"></div>
      <div className="gbiContent">
        <EchartsData type={chatType} data={charaData?.data} />
      </div>
    </div>
  );
}

export default GbiContent;
